<template>
  <div class="flex flex-col">
    <div class="mb-200">
      <div>
        <AddTeamNavItem :class="{ 'list-item': !addYourTeamCTAEnabled }" />
        <FreeSeatsIncentiveNavItem />
        <UpgradeNavItem
          v-if="isHybridReady"
          :class="{
            'list-item': true,
            'list-item--alt': addYourTeamCTAEnabled,
          }"
        />
      </div>
      <div class="mb-200 hide-smaller-height" />
      <NavItemsContainer class="flex flex-col flex-none">
        <NotificationsNavItem />
        <FeedbackNavItem v-if="shouldShowFeedback" />
        <HelpCenterNavItem v-if="showNewHelpCenter" />
        <HelpNavItem v-if="!showNewHelpCenter" />
        <OtherAppsNavItem />
        <ChatNavItem v-if="shouldShowChat" />
      </NavItemsContainer>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue-demi';
import { useCurrentAccount } from '@teamwork/use';
import useStore from '@/platform/composables/useStore';
import { useFeatures } from '@/platform/composables/useFeatures';
import { useHybrid } from '@/platform/composables/useHybrid';

export default {
  components: {
    UpgradeNavItem: () => import('./nav-items/UpgradeNavItem.vue'),
    AddTeamNavItem: () => import('./nav-items/AddTeamNavItem.vue'),
    NavItemsContainer: () => import('./nav-items/NavItemsContainer.vue'),
    NotificationsNavItem: () => import('./nav-items/NotificationsNavItem'),
    FeedbackNavItem: () => import('./nav-items/FeedbackNavItem.vue'),
    HelpNavItem: () => import('./nav-items/HelpNavItem.vue'),
    HelpCenterNavItem: () => import('./nav-items/HelpCenterNavItem.vue'),
    OtherAppsNavItem: () => import('./nav-items/OtherAppsNavItem.vue'),
    ChatNavItem: () => import('./nav-items/ChatNavItem.vue'),
    FreeSeatsIncentiveNavItem: () =>
      import('./nav-items/FreeSeatsIncentiveNavItem.vue'),
  },
  setup() {
    const store = useStore();
    const account = useCurrentAccount();
    const { isHybridReady } = useHybrid();
    const shouldShowChat = computed(() => {
      return account.value.chatEnabled && store.state.permissions.canAccessChat;
    });

    const {
      addYourTeamCTAEnabled,
      projectsHelpModalRevisionFlagEnabled,
      projectsHelpModalRevisionCustomersEnabled,
    } = useFeatures();

    const showNewHelpCenter = computed(() => {
      return (
        projectsHelpModalRevisionFlagEnabled.value ||
        projectsHelpModalRevisionCustomersEnabled.value
      );
    });

    const shouldShowFeedback = computed(
      () => account.value.installationTrackingEnabled,
    );

    return {
      addYourTeamCTAEnabled,
      projectsHelpModalRevisionFlagEnabled,
      shouldShowChat,
      showNewHelpCenter,
      shouldShowFeedback,
      isHybridReady,
    };
  },
};
</script>

<style scoped>
.list-item {
  border-top: 1px solid #2a2f40;
}

.list-item:last-child,
.list-item:only-child {
  border-top: 1px solid #2a2f40;
  border-bottom: 1px solid #2a2f40;
}

.list-item--alt {
  border-top: 0;
  border-bottom: 1px solid #2a2f40;
}

@media screen and (max-height: 740px) {
  .hide-smaller-height {
    display: none !important;
  }
}
</style>
